// extracted by mini-css-extract-plugin
export var black = "_39-6";
export var brand = "_39-1";
export var ddefault = "_39-0";
export var error = "_39-3";
export var gray = "_39-2";
export var highContrast = "_39-8";
export var outline = "_39-7";
export var success = "_39-5";
export var warning = "_39-4";